import React from 'react';
import logo from './img/dataa-logo-color.svg'
import bannerImg from './img/banner1.png'
import chainImg from './img/chain.svg'
import mgtImg from './img/mgt.svg'
import protocolImg from './img/protocol.svg'
import sceneImg from './img/scene.svg'
import flexibleImg from './img/flexible.svg'
import worthyImg from './img/worthy.svg'

import getEnv from '../env.js'

export const Nav30DataSource = {
  wrapper: { className: 'header3 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header3-logo',
    children: logo,
  },
  Menu: {
    className: 'header3-menu',
    children: [
      {
        name: 'item1',
        className: 'header3-item',
        children: {
          href: getEnv('REACT_APP_IDAAS_TENANT_CONSOLE_URL'),
          target: '_blank',
          children: [{ children: '控制台', name: 'text' }],
        },
      }
    ],
  },
  mobileMenu: { className: 'header3-mobile-menu' },
};
export const Banner50DataSource = {
  wrapper: { className: 'home-page-wrapper banner5 krq2mglvq4d-editor_css' },
  page: { className: 'home-page banner5-page' },
  childWrapper: {
    className: 'banner5-title-wrapper',
    children: [
      {
        name: 'explain',
        className: 'banner5-explain',
        children: '基于区块链的身份服务平台，帮助企业和开发者高效、安全地构建现代化身份管理基础设施。',
      },
      // {
      //   name: 'content',
      //   className: 'banner5-content',
      //   children: '产品的详细说明，如是什么东西之类的文字',
      // },
      {
        name: 'button',
        className: 'banner5-button-wrapper',
        children: {
          href: getEnv('REACT_APP_IDAAS_TENANT_CONSOLE_URL'),
          target: '_blank',
          className: 'banner5-button',
          type: 'primary',
          children: '开始使用',
        },
      },
    ],
  },
  image: {
    className: 'banner5-image',
    children: bannerImg,
  },
};
export const Feature30DataSource = {
  wrapper: { className: 'home-page-wrapper content3-wrapper' },
  page: { className: 'home-page content3' },
  OverPack: { playScale: 0.3 },
  // titleWrapper: {
  //   className: 'title-wrapper',
  //   children: [
  //     {
  //       name: 'title',
  //       children: '蚂蚁金融云提供专业的服务',
  //       className: 'title-h1',
  //     },
  //     {
  //       name: 'content',
  //       className: 'title-content',
  //       children: '基于阿里云强大的基础资源',
  //     },
  //   ],
  // },
  block: {
    className: 'content3-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children: chainImg,
          },
          textWrapper: { className: 'content3-text' },
          title: { className: 'content3-title', children: '区块链安全增强' },
          content: {
            className: 'content3-content',
            children:
              '区块链和智能合约技术加持，更安全、更可信、更可靠。',
          },
        },
      },
      {
        name: 'block1',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children: mgtImg,
          },
          textWrapper: { className: 'content3-text' },
          title: { className: 'content3-title', children: '5A服务能力' },
          content: {
            className: 'content3-content',
            children:
              '账户管理、认证管理、授权管理、应用管理、审计日志管理。',
          },
        },
      },
      {
        name: 'block2',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children: protocolImg,
          },
          textWrapper: { className: 'content3-text' },
          title: { className: 'content3-title', children: '标准协议支持' },
          content: {
            className: 'content3-content',
            children:
              'OIDC、OAuth2.0、SAML、LDAP、SSO，以及社交账户登录等，便于应用快速集成和开发。',
          },
        },
      },
      {
        name: 'block3',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children: sceneImg,
          },
          textWrapper: { className: 'content3-text' },
          title: { className: 'content3-title', children: '多场景业务支撑' },
          content: {
            className: 'content3-content',
            children:
              '一个平台，连接和管理客户、员工以及机器人。',
          },
        },
      },
      {
        name: 'block4',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children: flexibleImg,
          },
          textWrapper: { className: 'content3-text' },
          title: { className: 'content3-title', children: '灵活高效' },
          content: {
            className: 'content3-content',
            children:
              '可选开箱即用的IDaaS服务（即身份SaaS）或私有化部署，快速构建统一身份管理平台，并快速根据业务需求进行调整。',
          },
        },
      },
      {
        name: 'block5',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children: worthyImg,
          },
          textWrapper: { className: 'content3-text' },
          title: { className: 'content3-title', children: '用户价值' },
          content: {
            className: 'content3-content',
            children:
              '协助企业提高客户体验和员工管理效率，减小开发时间、降低运维成本，帮助企业省钱。',
          },
        },
      },
    ],
  },
};
export const Footer00DataSource = {
  wrapper: { className: 'home-page-wrapper footer0-wrapper' },
  OverPack: { className: 'home-page footer0', playScale: 0.05 },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        ©2021 <a href="http://www.dataarobotics.com/">Dataa Robotics</a> All Rights
        Reserved
      </span>
    ),
  },
};
